import React from 'react'

import CreditOverviewProfile from '../components/credit-overview/profile'

import {
	_getCheckQbToken, 
	_postQbCode, 
	_getQbInitialiseSelections,
} from '../services'

class CreditOverviewProfilePage extends React.Component{

	constructor(props){
		super(props);

		this.state = {
			qbAccessToken:true,
			gdAccessToken:true
		}

		let qbCode = new URLSearchParams(this.props.location.search).get('code')

		_getCheckQbToken()
		.then( res => {
			// console.log(res)
			if(res.data.accessToken){
				this.setState({qbAccessToken: true})
			} else {
				this.setState({qbAccessToken:false})
				if(qbCode){
					_postQbCode(qbCode)
					.then(res => {
						if(res.data.success){
							this.setState({qbAccessToken:true})
							_getQbInitialiseSelections()
						}
					})
				}
			}
		})
    }

	render(){
		return (
			<div style={{ margin: 16 }}>
				<CreditOverviewProfile />
			</div>
		)
	}

}

export default CreditOverviewProfilePage;


// WEBPACK FOOTER //
// ./src/containers/credit-overview-profile-page.js